import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from 'src/shared/auth/services/authentication.service';
import { ProductFeatures } from 'src/shared/auth/enums/product-features-enum';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProductFeaturesGuard  {
    constructor(private readonly router: Router, private readonly authenticationService: AuthenticationService) {}

    canActivate(next: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
        return this.authenticationService.checkIfFeatureGranted(next.data.productFeature as ProductFeatures).pipe(
            map(isGranted => {
                if (!isGranted) {
                    this.router.navigate(['/access-denied'], { replaceUrl: true });
                    return false;
                }
                return isGranted;
            })
        );
    }
}
